/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {freePlayGuideStepEnum} from '~/pages/game/LuckySlot/enum'
import {resolveCurrencyModeOnLimit} from '../components/silverCoins/constants'
import {InitialStateType} from './interface'

export enum BetResultStatusEnum { // 下注结果
  notEnough = 2,
  success = 1,
}

export const transOpenBoxData = (open_boxs = {}) => {
  const ret = []
  for (let i = 0; i < 6; i++) {
    if (open_boxs?.hasOwnProperty(i.toString())) {
      ret.push({
        isAuto: false,
        id: i,
        odd: open_boxs[i.toString()],
        notOpen: false,
      })
    } else {
      ret.push({
        id: i,
        notOpen: true,
      })
    }
  }
  return ret
}

export const lucky_slot_bet = createAsyncThunk(
  'lucky_slot_bet',
  async (arg: {room_id: number; currency_mode?: number}, store: any) => {
    const {betAreaSelected, isFreeSpin, radioSelected, isFreeCard} =
      store.getState().Animal_Rabbit.base
    const currentCurrencyMode =
      store.getState().Animal_Rabbit.home?.currency_mode
    const {from} = store.getState().env.otherInfo
    const {deviceinfo, clientIp} = store.getState().env
    const resp = await http.post(
      '/live/ground/ly_s_bet',
      {
        ...deviceinfo,
        ...arg,
        is_free_card: !isFreeSpin && isFreeCard, // freeSpin 优先级高于 freeCard
        is_free_spin: isFreeSpin,
        line_bet_coin: betAreaSelected.bet,
        bet_lines: betAreaSelected.line,
        is_auto_mod: radioSelected.isAuto,
        is_quick_mod: radioSelected.isQuick,
        source: from?.toString(),
        client_ip: clientIp,
        currency_mode: arg.currency_mode ?? currentCurrencyMode,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const get_slot_homepage = createAsyncThunk<
  any,
  {currency_mode?: number} | void
>('get_slot_homepage', async (arg, store: any) => {
  const {currency_mode} = (arg ?? {}) as {currency_mode?: number}
  const {deviceinfo} = store.getState().env
  const resp = await http.post(
    '/live/ground/ly_s_homepage',
    {
      ...deviceinfo,
      ...(currency_mode !== undefined ? {currency_mode} : {}),
    },
    {
      store,
      xcErrorToast: true,
    }
  )

  return resp.data.data
})
export const luckyslot_newer_fplay_main = createAsyncThunk(
  'luckyslot_newer_fplay_main',
  async (arg, store: any) => {
    const {deviceinfo, clientIp} = store.getState().env
    const resp = await http.post(
      '/live/ground/lt_n_fplay_main',
      {
        client_ip: clientIp,
        ...deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )

    return resp.data.data
  }
)

export const switch_currency_mode = createAsyncThunk(
  'luckySlot/switch_currency_mode',
  async (arg: {target_mode: number}, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/switch_currency_mode',
      {
        game_type: 11,
        target_mode: arg.target_mode,
        ...deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    await store.dispatch(get_slot_homepage({}))
    return resp.data.data
  }
)

const initialState: InitialStateType = {}

const initData = {
  finshPre: false,
  roundInfo: {
    shakeAwardsAmising: false, // 整体动画标志
    specail_elem_match_lines: null,
  },
  base: {
    stopShaking: false,
    isShaking: false,
    resultAmis: false,
    initMyCoin: false,
    playing: true,
    loading: true,
    betAreaSelected: {
      line: 0,
      bet: 0,
      showLine: false,
    },
    radioSelected: {
      isAuto: false,
      isQuick: false,
    },
    showGuide: false,
    isFreeSpin: false,
    isJackpotReward: false,
    isFreeCard: false,
  },
  home: {
    chip_game_visible: false,
    currency_mode: 0,
    my_chips: 0,
    chip_game_limit_reached: false,
  },
  webMessage: {},
  kingInfo: {},
  freePlay: {
    freePlayGuideStep: freePlayGuideStepEnum.none,
  },
  bonus_game: {},
}

export const luckySlotSlice = createSlice({
  name: 'Animal_Rabbit',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    updateFinshPre: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        finshPre: action.payload,
      })
    },
    updateTest: (state, action: PayloadAction<any>) => {
      const {roundInfo} = state
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          ...action.payload,
        },
      })
    },
    updateKingInfo: (state, action: PayloadAction<any>) => {
      const {kingInfo} = state
      Object.assign(state, {
        kingInfo: {
          ...kingInfo,
          ...action.payload,
        },
      })
    },
    updatePlaying: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          playing: action.payload,
        },
      })
    },
    updateResultAmis: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          resultAmis: action.payload,
        },
      })
    },
    updateWebMessage: (state, action: PayloadAction<any>) => {
      const {webMessage} = state
      Object.assign(state, {
        webMessage: {
          ...webMessage,
          ...action.payload,
          jackpot_pool:
            action.payload?.jackpot_pool || webMessage?.jackpot_pool,
        },
      })
    },
    updateBetAreaSelected: (state, action: PayloadAction<any>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          betAreaSelected: {
            ...base.betAreaSelected,
            ...action.payload,
          },
        },
      })
    },
    updateRadioSelected: (state, action: PayloadAction<any>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          radioSelected: {
            ...base.radioSelected,
            ...action.payload,
          },
        },
      })
    },
    updateBonusGame: (state, action: PayloadAction<any>) => {
      const {roundInfo} = state
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          bonus_game: {
            ...roundInfo.bonus_game,
            ...action.payload,
          },
        },
      })
    },
    updateFreePlay: (state, action: PayloadAction<any>) => {
      const {freePlay} = state
      Object.assign(state, {
        freePlay: {
          ...freePlay,
          ...action.payload,
        },
      })
    },
    updateStageTask: (state, action: PayloadAction<any>) => {
      const {roundInfo} = state
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          stage_task: action.payload,
        },
      })
    },
    updateMyCoins: (state, action: PayloadAction<number>) => {
      const {roundInfo} = state
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          my_coins: action.payload,
        },
      })
    },
    updateMyChips: (state, action: PayloadAction<number>) => {
      Object.assign(state.home, {
        my_chips: action.payload,
      })
    },
    updateLoading: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          loading: action.payload,
        },
      })
    },
    updateStopShaking: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          stopShaking: action.payload,
        },
      })
    },
    updateIsShaking: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          isShaking: action.payload,
        },
      })
    },
    updateShakeAwardsAmising: (state, action: PayloadAction<boolean>) => {
      const {roundInfo} = state
      Object.assign(state, {
        roundInfo: {
          ...roundInfo,
          shakeAwardsAmising: action.payload,
        },
      })
    },
    updateFreeSpin: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          isFreeSpin: action.payload,
        },
      })
    },
    updateIsJackpotReward: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          isJackpotReward: action.payload,
        },
      })
    },
    updateShowGuide: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          showGuide: action.payload,
        },
      })
    },
    updateInitMyCoin: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          initMyCoin: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(luckyslot_newer_fplay_main.fulfilled, (state, action) => {
      Object.assign(state, {
        freePlay: {
          ...state.freePlay,
          ...action.payload,
        },
      })
    })
    builder.addCase(get_slot_homepage.fulfilled, (state, action) => {
      const {open_boxs = {}} = action.payload.bonus_game
      const {slot_king, ...rest} = action.payload
      Object.assign(state, {
        roundInfo: {
          stage_task: rest.stage_task,
          bonus_game: {
            ...rest.bonus_game,
            open_boxs: transOpenBoxData(open_boxs),
          },
          free_spin: rest.free_spin,
          free_card: rest.card_list,
          my_coins: rest.my_coins,
          result: {
            prev: rest.init_broad,
            cur: rest.init_broad,
          },
        },
        home: {
          ...rest,
          bonus_game: {
            ...rest.bonus_game,
            open_boxs: transOpenBoxData(open_boxs),
          },
          currency_mode: resolveCurrencyModeOnLimit(
            rest.currency_mode ?? state.home?.currency_mode,
            rest.chip_game_limit_reached
          ),
        },
        base: {
          ...state.base,
          isFreeSpin: rest.free_spin?.left_num > 0,
          isFreeCard: rest.card_list?.length > 0,
        },
        webMessage: {
          ...state.webMessage,
          jackpot_pool: rest.jackpot_pool,
          h5_dmks: rest.h5_dmks,
        },
        kingInfo: {
          ...state.kingInfo,
          ...slot_king,
        },
      })
    })
    builder.addCase(lucky_slot_bet.fulfilled, (state, action) => {
      const {open_boxs = {}} = action.payload.bonus_game
      const {slot_king, my_chips, currency_mode, ...rest} = action.payload

      const data =
        rest.status === BetResultStatusEnum.success
          ? {
              roundInfo: {
                ...rest,
                free_card: rest.card_list,
                result: {
                  prev: state.roundInfo.result.cur,
                  cur: rest.result_broad,
                },
                bonus_game: {
                  ...rest.bonus_game,
                  open_boxs: transOpenBoxData(open_boxs),
                },
                shakeAwardsAmising: rest.status === BetResultStatusEnum.success,
              },
              home: {
                ...state.home,
                ...(my_chips !== undefined ? {my_chips} : {}),
                currency_mode: resolveCurrencyModeOnLimit(
                  currency_mode ?? state.home?.currency_mode,
                  state.home?.chip_game_limit_reached
                ),
              },
              webMessage: {
                ...state.webMessage,
                jackpot_pool: rest.jackpot_pool,
              },
              base: {
                ...state.base,
                isJackpotReward: !!rest.jackpot_reward,
                isFreeCard: rest.card_list?.length > 0,
              },
              kingInfo: {
                ...state.kingInfo,
                ...slot_king,
              },
            }
          : {
              roundInfo: {
                ...state.roundInfo,
                shakeAwardsAmising: rest.status === BetResultStatusEnum.success,
              },
            }
      Object.assign(state, data)
    })
    builder.addCase(lucky_slot_bet.rejected, (state, action) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          radioSelected: {
            ...base.radioSelected,
            isAuto: false,
          },
        },
      })
    })
    builder.addCase(switch_currency_mode.fulfilled, (state, action) => {
      const {home} = state
      Object.assign(state, {
        home: {
          ...home,
          currency_mode: action.payload.currency_mode,
        },
      })
    })
  },
})
export default luckySlotSlice.reducer
export const luckySlotActions = luckySlotSlice.actions
